//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles(my = false) {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let titleFontSize = '3rem';
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
		titleFontSize = '2rem';
	} else if (size === 'sm') {
		titleFontSize = '2rem';
	}
	if (isMobile) {
		titleFontSize = '2rem';
	}
	//#endregion

	return {
		outerStyle: ({bg} = {}) => {
			return {
				display: 'flex',
				flexDirection: 'column',
				padding: `0 ${minimumMarginX}rem`,
				margin: `${my ? 3 : 0}rem 0`,
				height: '100vh',
				backgroundImage: `url(${bg})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
			};
		},
		innerContainerStyle: () => {
			return {
				padding: '0 1rem 1rem 1rem',
				margin: 'auto',
				width: 'auto',
				height: 'auto',
				maxWidth: '90%',
				maxHeight: '90%',
				backgroundColor: 'rgba(37, 92, 153, 0.85)',
				borderRadius: '10px',
			};
		},
		titleStyle: () => {
			return {
				fontSize: titleFontSize,
				marginTop: '1rem',
				textAlign: 'center',
			};
		},
		textStyle: () => {
			return {
				marginTop: '1rem',
				color: 'white',
			};
		},
	};
}

export default Styles;
